import { useMemo } from "react";
export function useVirtualItems({ options, optionGroups, optionLabel, }) {
    const virtualItems = useMemo(() => {
        const items = [];
        if (Array.isArray(options)) {
            let index = 0;
            for (const option of options) {
                if (typeof option === "symbol") {
                    items.push({
                        type: "creatable-option",
                    });
                    index++;
                    continue;
                }
                items.push({
                    type: "option",
                    option,
                    index,
                });
                index++;
            }
            return items;
        }
        if (Array.isArray(optionGroups)) {
            // Item inside virtual list doesn't match an item inside Downshift
            // with the same index, because groups aren't included in Downshift items.
            // Because of that, we need to calculate the index for each option item
            // inside virtual list ourselves, while excluding groups.
            let index = 0;
            for (const optionGroup of optionGroups) {
                if (typeof optionGroup === "symbol") {
                    items.push({
                        type: "creatable-option",
                    });
                    index++;
                    continue;
                }
                items.push({
                    type: "group",
                    label: optionGroup.label,
                });
                for (const option of optionGroup.options) {
                    items.push({
                        type: "option",
                        option,
                        index: index++,
                    });
                }
            }
        }
        return items;
    }, [options, optionGroups]);
    const getVirtualItemKey = (virtualIndex) => {
        const item = virtualItems[virtualIndex];
        if (!item) {
            return String(virtualIndex);
        }
        if (item.type === "group") {
            return item.label;
        }
        if (item.type === "creatable-option") {
            return "creatable";
        }
        return optionLabel(item.option);
    };
    const getVirtualItemIndex = (downshiftIndex) => {
        if (Array.isArray(options)) {
            return downshiftIndex;
        }
        // `downshiftIndex` is an index of a currently highlighted option in Downshift,
        // which doesn't  match the index in a virtual list, because rows
        // with group labels in them aren't passed to Downshift and don't count when calculating index.
        return virtualItems.findIndex((virtualItem) => {
            return (virtualItem.type === "option" && virtualItem.index === downshiftIndex);
        });
    };
    return {
        virtualItems,
        getVirtualItemKey,
        getVirtualItemIndex,
    };
}
